<div class="subscription-report-statistics-wrapper">
    <div class="container-statistics">
        <div class="card">
            <p class="header-top">&nbsp;</p>
            <p class="header">
                Abonner på ukesrapport og få oversikt over alle eiendommer som er registrert og/eller solgt siste uke for det aktuelle området/områdene.
            </p>
            <p></p>
            <p class="sub-header">Rapporten baseres på de områdene og filterinnstillingene du har valgt.</p>
        </div>
        <div class="card-btn align-center button-wrapper">
            <div (click)="openExamplePdf()" class="btn pdf">&nbsp;&nbsp;&nbsp;Se eksempel på ukesrapport</div>
        </div>
        <div class="card-btn align-center button-wrapper">
            <div (click)="openDialog()" class="btn generate">&nbsp;&nbsp;&nbsp;Abonner</div>
        </div>
        <div class="more-info-accordion">
            <div class="header" (click)="infoToggleOpen = !infoToggleOpen">
                <div class="text">Mer info</div>
                <div class="icon" [class.is-open]="infoToggleOpen"></div>
            </div>
            <div class="content" [class.is-open]="!infoToggleOpen">
                <div class="card no-pad">
                    <p class="content-header">Slik velger du område</p>
                    <p class="content-text">Det er flere måter å velge et område på:</p>
                    <ol>
                        <li>Juster kartutsnittet i nettleservinduet til ønsket utsnitt</li>
                        <li>
                            Bruk områdevelgeren for å søke opp og sette sammen flere områder. <br />
                            Eksempelvis kommuner, bydeler, postnummer, grunnkretser
                        </li>
                        <li>Tegn ett eller flere områder i kartet med tegneverktøyet</li>
                        <li>Søk opp et område via søket. Eksempelvis et postnummer eller en kommune for å få ferdig polygon i kartet</li>
                    </ol>
                    <p class="content-header">Filterinnstillinger</p>
                    <p class="content-text">
                        evKart har standard valgte filterinnstillinger. Dersom disse innstillingene passer for deg, trenger du ikke gjøre noe. Hvis du justerer
                        på filtrene, vil justeringene hensyntas i ukesrapporten.
                    </p>

                    <p class="content-text">
                        Du kan ikke justere på område eller filter etter at ukesrapporten er abonnert på. Da må du avslutte abonnementet og opprette en ny
                        ukesrapport
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
@if (showSubscriptionsReportWizard) {
    <subscription-report-wizard (onClose)="closeDialog()"></subscription-report-wizard>
}
